module.exports = __webpack_public_path__ + "img/W-S38.d7d07efa.jpg";